import { ChangeDetectionStrategy, Component } from '@angular/core';
import { APP_VERSION, IconNames, YEAR_DATE_FORMAT } from '../../../common/constants';
import { format } from 'date-fns';

@Component({
  selector: 'container-dashboard-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  appVersion = APP_VERSION;
  isCollapsed = true;
  currentYear: string = format(new Date(), YEAR_DATE_FORMAT);
  iconNames = IconNames;
}
